import React from "react";
import { useClassNames } from "../../shared/hooks";
import styles from "./styles.module.scss";

type LoaderPorps = {
  isContainerWide?: boolean;
  containerHeight?: number;
};
const Loader = ({
  isContainerWide,
  containerHeight,
}: LoaderPorps): JSX.Element => {
  const classNames = useClassNames([
    styles.Loader,
    isContainerWide ? styles["Loader--wide"] : "",
  ]);

  return (
    <div
      className={classNames}
      style={containerHeight ? { height: `${containerHeight}px` } : {}}
    >
      <div className={styles["Loader-circle"]}>
        <svg viewBox="0 0 80 80">
          <circle id="test" cx="40" cy="40" r="32" />
        </svg>
      </div>
    </div>
  );
};

export default Loader;
